import React, { useEffect, useState } from "react";
import { Button, Col, Row } from "react-bootstrap";
import { apiRoutes } from "../../hooks/apiClient";
import OrigemOsPaginatedView from "../../components/UI/PaginatedView/OrigemOsPaginatedView";
import { formatarData } from "../../components/Formatters/DateTime";

const ConsultaOrigemOrdemServico = ({ location, history }) => {
  const [title, setTitle] = useState("");
  const { state } = location;

  const columns = [
    {
      name: `Nº da ${title}`,
      cell: (row) => row.sequencial,
      maxWidth: "220px",
      center: true,
      sortable: true,
    },
    {
      name: "Inscrição Estadual",
      cell: (row) => row.incricaoEstadual,
      maxWidth: "190px",
      center: true,
      sortable: true,
    },
    {
      name: "CNPJ/CPF",
      cell: (row) => row.cpfCnpj,
      maxWidth: "190px",
      center: true,
      sortable: true,
    },
    {
      name: "Razão Social",
      cell: (row) => row.nomeFormal,
      maxWidth: "100%",
      sortable: true,
    },
    {
      name: "Data de Inclusão",
      cell: (row) => formatarData(row.dataInclusao),
      selector: "dataInclusao",
      maxWidth: "190px",
      center: true,
      sortable: true,
    },
  ];

  useEffect(() => {
    if (state && state.tipoOrigem) {
      if (state.tipoOrigem === "D") setTitle("Denúncia");
      else if (state.tipoOrigem === "P") setTitle("Parte de Serviço");
      else setTitle("Cobrança");
    }
  }, [state]);

  return (
    <>
      <Row>
        <Col sm="12">
          <h1 className="h3 mb-4 text-gray-800">Gerar Ordem de Serviço </h1>
        </Col>
      </Row>
      <OrigemOsPaginatedView
        title={title}
        keyField="sequencial"
        descriptionField="sequencial"
        defaultSearch
        defaultSearchPlaceholder={`Digite o Nº da ${title}`}
        queryService={apiRoutes.fiscalizacao.ordemservico.listaOrigemOs}
        editRoute="/app/os/origem/form"
        columns={columns}
        advancedParameters={state}
        history={history}
      />
      <Row>
        <Col sm="12">
          <Button variant="danger" onClick={() => history.goBack()}>
            Cancelar
          </Button>
        </Col>
      </Row>
    </>
  );
};

export default ConsultaOrigemOrdemServico;
